// extracted by mini-css-extract-plugin
var _1 = "select--PUvyV";
export { _1 as "select" }
